<template>
  <!-- 后续拆分 注册 登录组件 与公共函数 -->
  <PublicPopup ref="LoginRegisterPopupRef" @close="handleCloseEmit">
    <template #content>
      <div class="popup-view">
        <van-tabs v-model:active="activeName" :line-width="100" :line-height="2">
          <template #nav-bottom>
            <div class="tabs-bot-line"></div>
          </template>

          <!-- 注册 Registro -->
          <van-tab :title="$t('login-register-popup-index.registerTab')" name="register">
            <template #title>
              <div class="tab-header-container chxy-row-c-c">
                <img
                  :src="
                    getImageUrlWithCDN_TEST(
                      `/login/reg-${activeName === 'register' ? 'add' : 'add2'}.png`
                    )
                  "
                  class="icon register"
                />
                <span class="title">{{ $t('login-register-popup-index.registerTab') }}</span>
              </div>
            </template>
            <div class="suporte-content-text">
              <span>{{ $t('login-register-popup-index.registerSupport') }}</span>
            </div>

            <van-form autocomplete="off" @submit="registerHandle">
              <van-field
                v-model="postDataReg.username"
                :clearable="true"
                name="username"
                :placeholder="$t('login-register-popup-index.enterMobileOrAccount')"
                label="*"
                maxlength="16"
                class="custom-label"
                :class="{
                  'label-line': accountSwitchType == PHONE,
                  'user-name': accountSwitchType != PHONE,
                }"
                :border="true"
                autocomplete="off"
                @input="handleUsernameInput"
                @keydown="handleUsernameKeydown"
                @compositionstart="handleCompositionStart"
                @compositionend="handleCompositionEnd"
                @blur="verifyRegistro1"
              >
                <template #left-icon>
                  <div v-if="accountSwitchType != PHONE" class="icon-container">
                    <img :src="getImageUrlWithCDN_TEST('/login/user.png')" class="user-icon" />
                  </div>
                  <div v-else class="chxy-row-ac">
                    <img
                      :src="
                        getImageUrlWithCDN_TEST(
                          isMX ? '/login/login-pt-mx.png' : '/login/login-pt.png',
                          'local'
                        )
                      "
                      class="login-pt-icon"
                    />
                    <div class="login-pt-55">
                      {{ $t('login-register-popup-index.phoneCode') }}
                    </div>
                  </div>
                </template>
              </van-field>
              <div
                v-if="
                  registroModal.registro1error || (similarUsernames && similarUsernames.length > 0)
                "
                class="registroerror"
              >
                <img :src="getImageUrlWithCDN_TEST('/danger.png')" class="registroerror-icon" />
                <div v-if="registroModal.registro1error" class="registroerror-text">
                  {{ registroModal.registro1error }}123123
                </div>
                <div
                  v-if="similarUsernames && similarUsernames.length > 0"
                  class="registroerror-text flex flex-wrap"
                >
                  <span class="text-[var(--special-red-10)]">
                    {{ $t('login-register-popup-index.memberExists') }}
                  </span>
                  <span class="text-[var(--login-popup-tips-content)]">
                    {{ $t('login-register-popup-index.suggestion') }}
                  </span>
                  <span v-for="item in similarUsernames" :key="item" class="username-text">
                    {{ item }}
                  </span>
                </div>
              </div>
              <!-- --login-popup-confirm-bg -->
              <div v-if="shouldShowAccountSwitch" class="account-switch-type">
                <van-radio-group
                  v-model="accountSwitchType"
                  direction="horizontal"
                  icon-size="16"
                  checked-color="var(--login-popup-confirm-bg)"
                >
                  <van-radio :name="PHONE" class="radio-item" shape="square">
                    {{ $t('login-register-popup-index.setAsCellphone') }}
                  </van-radio>
                  <van-radio :name="ACCOUNT" class="radio-item" shape="square">
                    {{ $t('login-register-popup-index.setAsAccount') }}
                  </van-radio>
                </van-radio-group>
              </div>
              <van-field
                v-model="postDataReg.password"
                :clearable="true"
                :type="isPasswordVisible ? 'text' : 'password'"
                name="password"
                :placeholder="$t('login-register-popup-index.password')"
                label="*"
                maxlength="16"
                class="custom-label"
                :border="true"
                autocomplete="off"
                @update:model-value="verifyInputRegistro2"
                @blur="verifyInputRegistro2"
              >
                <template #left-icon>
                  <div class="icon-container">
                    <img :src="getImageUrlWithCDN_TEST('/login/lock.png')" class="lock-icon" />
                  </div>
                </template>

                <template #button>
                  <img
                    v-if="isPasswordVisible"
                    :src="getImageUrlWithCDN_TEST('/login/eye.png')"
                    class="eye-icon"
                    @click="togglePasswordVisibility"
                  />
                  <img
                    v-else
                    :src="getImageUrlWithCDN_TEST('/login/closed-eye.png')"
                    class="eye-close-icon"
                    @click="togglePasswordVisibility"
                  />
                </template>
              </van-field>
              <div v-if="registroModal.registro2error" class="chxy-row-ac registroerror">
                <img :src="getImageUrlWithCDN_TEST('/danger.png')" class="registroerror-icon" />
                <div class="registroerror-text">{{ registroModal.registro2error }}</div>
              </div>

              <div class="forca-container chxy-row-ac">
                <div class="forca">
                  {{ $t('login-register-popup-index.strength') }}
                </div>
                <div class="chxy-row-ac">
                  <div
                    v-for="(level, index) in 4"
                    :key="index"
                    :class="['forca-level-other', { 'forca-level': index < passwordStrength }]"
                  ></div>
                </div>
              </div>

              <van-field
                v-if="!isPasswordVisible"
                v-model="postDataReg.password_confirm"
                :clearable="true"
                :type="isPasswordConfirVisible ? 'text' : 'password'"
                name="password_confirm"
                :placeholder="$t('login-register-popup-index.confirmPassword')"
                left-icon="closed-eye"
                label="*"
                class="custom-label confirm-again"
                :border="true"
                autocomplete="off"
                @update:model-value="verifyInputRegistro3"
              >
                <template #left-icon>
                  <div class="icon-container">
                    <img :src="getImageUrlWithCDN_TEST('/login/lock.png')" class="lock-icon" />
                  </div>
                </template>
                <template #button>
                  <img
                    v-if="isPasswordConfirVisible"
                    :src="getImageUrlWithCDN_TEST('/login/eye.png')"
                    class="eye-icon"
                    @click="togglePasswordConfirVisibility"
                  />
                  <img
                    v-else
                    :src="getImageUrlWithCDN_TEST('/login/closed-eye.png')"
                    class="eye-close-icon"
                    @click="togglePasswordConfirVisibility"
                  />
                </template>
              </van-field>
              <div
                v-if="registroModal.registro3error && !isPasswordVisible"
                class="chxy-row-ac registroerror"
              >
                <img :src="getImageUrlWithCDN_TEST('/danger.png')" class="registroerror-icon" />
                <div class="registroerror-text">{{ registroModal.registro3error }}</div>
              </div>

              <template v-if="accountSwitchType != PHONE">
                <van-field
                  v-model="postDataReg.phone"
                  :clearable="true"
                  name="phone"
                  type="number"
                  :placeholder="$t('login-register-popup-index.enterMobile')"
                  label="*"
                  maxlength="11"
                  class="custom-label label-line"
                  :border="true"
                  autocomplete="off"
                  @update:model-value="verifyInputRegistro4"
                >
                  <template #left-icon>
                    <div class="chxy-row-ac">
                      <img
                        :src="
                          getImageUrlWithCDN_TEST(
                            isMX ? '/login/login-pt-mx.png' : '/login/login-pt.png',
                            'local'
                          )
                        "
                        class="login-pt-icon"
                      />
                      <div class="login-pt-55">
                        {{ $t('login-register-popup-index.phoneCode') }}
                      </div>
                    </div>
                  </template>
                </van-field>
                <div v-if="registroModal.registro4error" class="chxy-row-ac registroerror">
                  <img class="registroerror-icon" :src="getImageUrlWithCDN_TEST('/danger.png')" />
                  <div class="registroerror-text">{{ registroModal.registro4error }}</div>
                </div>
              </template>
              <div class="determina chxy-row">
                <van-checkbox
                  v-model="checkedReg"
                  class="checkbox-item"
                  shape="square"
                ></van-checkbox>
                <span class="determina-text">
                  <span class="label">{{ $t('login-register-popup-index.ageAgree') }}</span>
                  <span class="acordo" @click="handleUserAgreementPopupOpen">
                    {{ $t('login-register-popup-index.userAgreement') }}
                  </span>
                </span>
              </div>

              <div class="h-10"></div>

              <!-- 注册按钮 -->
              <div class="submit-button-box chxy-column-c-c">
                <div class="submit-button-border-ani"></div>
                <van-button
                  :loading="loading"
                  type="primary"
                  native-type="submit"
                  block
                  class="submit-button register-button"
                >
                  <template #loading>
                    <span class="loading-dots">
                      {{ $t('login-register-popup-index.registering') }}
                    </span>
                  </template>
                  {{ $t('login-register-popup-index.register') }}
                </van-button>
              </div>
              <div class="h-10"></div>
              <div class="chxy-row-c-c register-row" @click="toCliente">
                <div>{{ $t('login-register-popup-index.customerSupport') }}</div>
              </div>
            </van-form>
          </van-tab>

          <!-- 登录 Login  :title="$t('login.LoginNow')" -->
          <van-tab :title="$t('login-register-popup-index.loginTab')" name="login">
            <template #title>
              <div class="tab-header-container chxy-row-c-c">
                <img
                  :src="
                    getImageUrlWithCDN_TEST(
                      `/login/log-${activeName === 'login' ? 'add2' : 'add'}.png`
                    )
                  "
                  class="icon login"
                />
                <span class="title">{{ $t('login-register-popup-index.loginTab') }}</span>
              </div>
            </template>
            <div class="suporte-content-text">
              <span>{{ $t('login-register-popup-index.loginSupport') }}</span>
            </div>
            <van-form :model="postData" @submit="loginHandle">
              <van-field
                v-model="postData.username"
                :clearable="true"
                name="username"
                :placeholder="$t('login-register-popup-index.enterMobileOrAccount')"
                label="*"
                maxlength="16"
                left-icon="contact"
                class="custom-label"
                :border="true"
                @input="handleLoginUsernameInput"
                @keydown="handleLoginUsernameKeydown"
                @compositionstart="handleLoginCompositionStart"
                @compositionend="handleLoginCompositionEnd"
                @update:model-value="verifyInputLogin1"
              >
                <template #left-icon>
                  <div class="icon-container">
                    <img :src="getImageUrlWithCDN_TEST('/login/user.png')" class="user-icon" />
                  </div>
                </template>
              </van-field>
              <div v-if="loginModal.login1error" class="chxy-row-ac registroerror">
                <img class="registroerror-icon" :src="getImageUrlWithCDN_TEST('/danger.png')" />
                <div class="registroerror-text">{{ loginModal.login1error }}</div>
              </div>

              <van-field
                v-model="postData.password"
                :clearable="true"
                :type="loginPasswordConfirVisible ? 'text' : 'password'"
                name="password"
                :placeholder="$t('login-register-popup-index.password')"
                label="*"
                maxlength="16"
                left-icon="closed-eye"
                class="custom-label"
                :border="true"
                @update:model-value="verifyInputLogin2"
              >
                <template #left-icon>
                  <div class="icon-container">
                    <img :src="getImageUrlWithCDN_TEST('/login/lock.png')" class="lock-icon" />
                  </div>
                </template>

                <template #button>
                  <img
                    v-if="loginPasswordConfirVisible"
                    :src="getImageUrlWithCDN_TEST('/login/eye.png')"
                    class="eye-icon"
                    @click="loginPasswordFun"
                  />
                  <img
                    v-else
                    :src="getImageUrlWithCDN_TEST('/login/closed-eye.png')"
                    class="eye-close-icon"
                    @click="loginPasswordFun"
                  />
                </template>
              </van-field>
              <div v-if="loginModal.login2error" class="chxy-row-ac registroerror">
                <img class="registroerror-icon" :src="getImageUrlWithCDN_TEST('/danger.png')" />
                <div class="registroerror-text">{{ loginModal.login2error }}</div>
              </div>

              <div class="lembrar chxy-row-ac">
                <van-checkbox
                  v-model="checkedLogin"
                  class="checkbox-item"
                  shape="square"
                ></van-checkbox>
                <span class="value">{{ $t('login-register-popup-index.rememberPassword') }}</span>
              </div>

              <div class="mt-4 submit-button-box">
                <div class="submit-button-border-ani"></div>
                <van-button
                  :loading="loading"
                  type="primary"
                  native-type="submit"
                  block
                  class="submit-button login-button"
                >
                  <template #loading>
                    <span class="loading-dots">
                      {{ $t('login-register-popup-index.loggingIn') }}
                    </span>
                  </template>
                  <!-- {{ $t('login.Login') }} -->
                  {{ $t('login-register-popup-index.login') }}
                </van-button>
              </div>
            </van-form>

            <div class="login-tip chxy-row-bt">
              <span class="left-text" @click="toCliente">
                {{ $t('login-register-popup-index.customerSupport') }}
              </span>
              <span class="right-text" @click="handleForgetPwd">
                {{ $t('login-register-popup-index.forgotPassword') }}
              </span>
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </template>
  </PublicPopup>

  <!-- 忘记密码弹窗 -->
  <ForgetPassword v-model:show="forgetPasswordVisible" @close="closeForgetPwd" />

  <!-- 错误信息弹窗 -->
  <ClosePopup ref="ErrorPopupRef">
    <template #header>
      <div class="error-header">
        <van-icon name="warning-o" color="#EA4E3D" size="20" />
        <span class="title">{{ $t('login-register-popup-index.errorTitle') }}</span>
      </div>
    </template>
    <template #content>
      <div class="error-content">
        <div class="prompt">
          <span>{{ $t('login-register-popup-index.errorCredentials') }}</span>
        </div>
        <div class="button" @click="handleCloseErrorPopup">
          {{ $t('login-register-popup-index.errorConfirm') }}
        </div>
      </div>
    </template>
  </ClosePopup>

  <!-- 用户协议 -->
  <UserAgreementPopup ref="UserAgreementPopupRef" />
</template>

<script setup>
import { REMEMBER_CREDENTIALS_KEY } from '@/stores/mutation-type' // 定义记住账号和密码的存储键名
import { ref, reactive, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useUserStore, usePathsStore } from '@/stores'
import { useI18n } from 'vue-i18n'
import { useEventBus } from '@vueuse/core'
import vw from '@/utils/inline-px-to-vw'
import { showNotify } from 'vant'
import { v4 as uuidv4 } from 'uuid'
import { errorToast } from '@/utils/toast'
import { officialChannelLoginListApi } from '@/api/messages'
import { isBrazil, isMX } from '@/utils/i18n'
// 创建eventBus实例
const eventBus = useEventBus('refreshHomeInfo')

const { t } = useI18n()
const router = useRouter()
const userStore = useUserStore()
const pathsStore = usePathsStore()
const loading = ref(false)
const activeName = ref('register')
const checkedReg = ref(true)
const checkedLogin = ref(true)
const isPasswordVisible = ref(false) // 控制密码框是否可见
const isPasswordConfirVisible = ref(false) // 控制密码框是否可见
const loginPasswordConfirVisible = ref(false) // 控制登录密码框是否可见

const LoginRegisterPopupRef = ref(null)

const registroModal = reactive({
  registro1error: '',
  registro2error: '',
  registro3error: '',
  registro4error: '',
})
const loginModal = reactive({
  login1error: '',
  login2error: '',
})
const postDataReg = reactive({
  username: '',
  password: '',
  password_confirm: '',
  phone: '',
})
const postData = reactive({
  username: '',
  password: '',
})

/**
 * --------------------------- 注册切换账号 start ---------------------------
 */

const PHONE = 'phone'
const ACCOUNT = 'account'
const accountSwitchType = ref(ACCOUNT)

const shouldShowAccountSwitch = computed(() => {
  const val = postDataReg.username
  if (!val) return false

  // 纯数字且长度在 6～12 之间 → 显示
  if (/^\d+$/.test(val) && val.length >= 6 && val.length <= 12) return true

  // 纯数字且长度 ≥13 → 隐藏
  if (/^\d+$/.test(val) && val.length >= 13) return false

  // 包含字母（纯字母或字母数字混合）→ 隐藏
  if (/[a-zA-Z]/.test(val)) return false

  // 其他情况（比如特殊符号）→ 隐藏
  return false
})

const validateUsernameAsPhone = () => {
  if (accountSwitchType.value !== PHONE) {
    // 如果不是手机号模式，清除手机号相关的错误（如果有）
    registroModal.registro1error = ''
    return
  }
  const phone = postDataReg.username.trim()
  if (!phone) {
    registroModal.registro1error = t('login-register-popup-index.enterMobile')
    return
  }
  // 手机号校验规则：纯数字，长度10~11（可根据实际国家调整）
  if (!/^\d{10,11}$/.test(phone)) {
    registroModal.registro1error = t('login-register-popup-index.phoneFormat')
  } else {
    registroModal.registro1error = ''
  }
}

watch(
  () => postDataReg.username,
  () => {
    if (!shouldShowAccountSwitch.value) {
      accountSwitchType.value = ACCOUNT
      registroModal.registro1error = ''
    } else if (accountSwitchType.value === PHONE) {
      validateUsernameAsPhone()
    }
  }
)

watch(accountSwitchType, (newVal) => {
  if (newVal === PHONE) {
    validateUsernameAsPhone()
  } else {
    // 切换到账号模式，清除手机号相关错误（保留其他错误）
    registroModal.registro1error = ''
  }
})
/**
 * --------------------------- 注册切换账号 end   ---------------------------
 */

const emit = defineEmits(['close', 'closeSuccessRegisterPopup', 'closeLoginRegisterPopup'])

const verifyInputLogin1 = () => {
  let result = true
  if (postData.username.trim().length < 1) {
    loginModal.login1error = t('login-register-popup-index.enterMobileOrAccount')
  } else if (postData.username.length < 4 || postData.username.length > 16) {
    loginModal.login1error = t('login-register-popup-index.accountFormatError')
  } else {
    loginModal.login1error = ''
    result = false
  }
  return result
}

const verifyInputLogin2 = () => {
  let result = true
  if (postData.password.trim().length < 1) {
    loginModal.login2error = t('login-register-popup-index.passwordRequired')
  } else if (postData.password.length < 6 || postData.password.length > 16) {
    loginModal.login2error = t('login-register-popup-index.passwordFormatLogin')
  } else {
    loginModal.login2error = ''
    result = false
  }
  return result
}

const verifyRegistro1 = () => {
  let result = true
  const username = postDataReg.username.trim()
  // 巴西 / 西语：均允许纯数字账号
  const usernameReg = /^[a-zA-Z0-9]+$/

  if (username.length < 1) {
    registroModal.registro1error = t('login-register-popup-index.enterAccount')
  } else if (username.length < 4 || username.length > 16) {
    registroModal.registro1error = t('login-register-popup-index.accountFormatError')
  } else if ((isBrazil.value || isMX.value) && !usernameReg.test(username)) {
    registroModal.registro1error = t('login-register-popup-index.accountFormatError')
  } else {
    registroModal.registro1error = ''
    result = false
  }
  // 账号变更后，若密码已填写则重新校验「账号密码不能相同」
  if (postDataReg.password.trim().length > 0) {
    verifyInputRegistro2()
  }
  // console.log('verifyRegistro1...')
  return result
}

const verifyInputRegistro2 = (value) => {
  let result = true
  // 优先使用事件传入的最新值，避免 v-model 尚未同步时校验到旧密码
  const password = String(typeof value === 'string' ? value : postDataReg.password).trim()
  const username = postDataReg.username.trim()

  if (password.length < 1) {
    registroModal.registro2error = t('login-register-popup-index.passwordRequired')
  } else if (username && password.toLowerCase() === username.toLowerCase()) {
    // 账号与密码相同：优先于格式校验提示
    registroModal.registro2error = t('login-register-popup-index.accountPasswordSame')
  } else if (password.length < 6) {
    registroModal.registro2error = t('login-register-popup-index.passwordFormatRegister')
  } else {
    // 检查字符类型：字母、数字、特殊字符
    const hasLetter = /[a-zA-Z]/.test(password)
    const hasDigit = /\d/.test(password)
    const hasSpecialChar = /[!@#$%^&*()_+=[\]{};':"\\|,.<>?~`-]/.test(password)

    // 计算包含的字符类型数量
    const charTypesCount = (hasLetter ? 1 : 0) + (hasDigit ? 1 : 0) + (hasSpecialChar ? 1 : 0)

    if (charTypesCount < 2) {
      registroModal.registro2error = t('login-register-popup-index.passwordFormatRegister')
    } else {
      result = false
      registroModal.registro2error = ''
    }
  }
  // console.log('verifyRegistro2...')
  return result
}

const verifyInputRegistro3 = () => {
  let result = true
  const password_confirm = postDataReg.password_confirm.trim()
  if (password_confirm.length < 1) {
    registroModal.registro3error = t('login-register-popup-index.confirmPasswordEmpty')
  } else if (postDataReg.password.trim() !== password_confirm) {
    registroModal.registro3error = t('login-register-popup-index.passwordsMismatch')
  } else {
    result = false
    registroModal.registro3error = ''
  }
  // console.log('verifyRegistro3...')
  return result
}

const verifyInputRegistro4 = () => {
  let result = true
  // 账号如果选择手机号，这边校验账号
  if (accountSwitchType.value === PHONE) {
    const phone = postDataReg.username.trim()
    if (phone.length < 1) {
      registroModal.registro1error = t('login-register-popup-index.phoneEmpty')
    } else if (phone.length < 10) {
      registroModal.registro1error = t('login-register-popup-index.phoneFormat')
    } else {
      result = false
      registroModal.registro1error = ''
    }
    // console.log('verifyInputRegistro4...')
    return result
  } else {
    const phone = postDataReg.phone.trim()
    if (phone.length < 1) {
      registroModal.registro4error = t('login-register-popup-index.phoneEmpty')
    } else if (phone.length < 10) {
      registroModal.registro4error = t('login-register-popup-index.phoneFormat')
    } else {
      result = false
      registroModal.registro4error = ''
    }
    // console.log('verifyInputRegistro4...')
    return result
  }
}

const handleCloseSuccessRegisterPopup = () => {
  nextTick(() => {
    LoginRegisterPopupRef.value.close()
  })
  emit('closeSuccessRegisterPopup')
}

const handleCloseLoginRegisterPopup = () => {
  handleCloseEmit()
  nextTick(() => {
    LoginRegisterPopupRef.value.close()
  })
}
const handleCloseEmit = () => {
  emit('closeLoginRegisterPopup')
}

/**
 * 用户协议弹窗
 */
const UserAgreementPopupRef = ref(null)
const handleUserAgreementPopupOpen = () => {
  nextTick(() => {
    UserAgreementPopupRef.value.open()
  })
}

// 生成或获取设备唯一标识 (这是一个简单示例，您可能需要更稳定的方案)
const generateDeviceId = () => {
  let deviceId = ''
  if (localStorage.getItem('deviceId')) {
    deviceId = localStorage.getItem('deviceId')
  } else {
    deviceId = uuidv4().replace(/-/g, '')
    localStorage.setItem('deviceId', uuidv4().replace(/-/g, ''))
  }
  return deviceId
}

// 使用现代API获取设备信息 (替代已弃用的属性)[6](@ref)
const getDeviceInfo = async () => {
  const deviceInfo = {
    device_id: generateDeviceId(),
  }
  // 1. 尝试使用新的 userAgentData API (现代浏览器)
  if (navigator.userAgentData) {
    try {
      const highEntropyData = await navigator.userAgentData.getHighEntropyValues([
        'platform',
        'platformVersion',
        'model',
        'fullVersionList',
      ])
      deviceInfo.os_name = highEntropyData.platform
      deviceInfo.os_version = highEntropyData.platformVersion
      deviceInfo.device_model = highEntropyData.model

      // 从 fullVersionList 中获取浏览器信息
      const chromeBrand = highEntropyData.fullVersionList.find((item) => item.brand === 'Chromium')
      if (chromeBrand) {
        deviceInfo.brower_type = `${chromeBrand.brand} v${chromeBrand.version}`
      }
    } catch (error) {
      console.warn('获取高熵值 User-Agent 数据失败:', error)
    }
  }

  // 2. 降级方案：分析 User-Agent 字符串 (兼容旧浏览器)
  const ua = navigator.userAgent
  if (!deviceInfo.brower_type) {
    if (ua.includes('Chrome'))
      deviceInfo.brower_type = 'Chrome' + (ua.match(/Chrome\/([\d.]+)/)?.[1] || '')
    else if (ua.includes('Firefox'))
      deviceInfo.brower_type = 'Firefox' + (ua.match(/Firefox\/([\d.]+)/)?.[1] || '')
    else if (ua.includes('Safari'))
      deviceInfo.brower_type = 'Safari' + (ua.match(/Version\/([\d.]+)/)?.[1] || '')
  }

  if (!deviceInfo.os_name) {
    if (ua.includes('Windows')) deviceInfo.os_name = 'Windows'
    else if (ua.includes('Mac')) deviceInfo.os_name = 'macOS'
    else if (ua.includes('Linux')) deviceInfo.os_name = 'Linux'
    else if (ua.includes('Android')) deviceInfo.os_name = 'Android'
    else if (ua.includes('iOS') || ua.includes('iPad') || ua.includes('iPhone'))
      deviceInfo.os_name = 'iOS'
  }

  // 3. 补充其他信息
  deviceInfo.client_name = 'H5' // 可根据实际情况修改，例如从项目配置中读取版本号

  // 设备品牌信息通常需要特定API或UA分析，这里简单示例
  if (ua.includes('Android'))
    deviceInfo.device_brand = ua.match(/(?<=; )(.*?)(?= Build)/)?.[0] || 'Android Device'
  if (/(iPhone|iPad|iPod)/.test(ua)) deviceInfo.device_brand = 'Apple'

  return deviceInfo
}

const ErrorPopupRef = ref(null)
const handleOpenErrorPopup = () => {
  ErrorPopupRef.value.openPopupClose()
}
const handleCloseErrorPopup = () => {
  ErrorPopupRef.value.closePopup()
}

// 切换密码可见性
const togglePasswordVisibility = () => {
  isPasswordVisible.value = !isPasswordVisible.value
}

// 切换密码可见性
const togglePasswordConfirVisibility = () => {
  isPasswordConfirVisible.value = !isPasswordConfirVisible.value
}

// 切换密码可见性
const loginPasswordFun = () => {
  loginPasswordConfirVisible.value = !loginPasswordConfirVisible.value
}

const passwordStrength = ref(0) // 密码强度等级（0-3）

const calculatePasswordStrength = (password) => {
  let strength = 0

  // 规则1：长度 >= 6
  if (password.length >= 6) strength += 1

  // 规则2：包含数字
  if (/\d/.test(password)) strength += 1

  // 规则3：包含特殊字符
  if (/[!@#$%^&*(),.?":{}|<>]/.test(password)) strength += 1

  // 规则4：长度 >= 10（新增规则）
  if (password.length >= 10) strength += 1

  // 限制强度最大值为4
  passwordStrength.value = Math.min(strength, 4)
}

watch(
  () => postDataReg.password,
  (newPassword) => {
    calculatePasswordStrength(newPassword.trim())
  }
)

// 在组件挂载时检查是否有记住的账号和密码
onMounted(() => {
  // console.log('检查是否有记住的账号和密码')
  const rememberedCredentials = localStorage.getItem(REMEMBER_CREDENTIALS_KEY)
  // console.log('localStorage中的记住凭据:', rememberedCredentials)
  if (rememberedCredentials) {
    try {
      const credentials = JSON.parse(rememberedCredentials)
      // console.log('解析后的凭据:', credentials)
      postData.username = credentials.username || ''
      postData.password = credentials.password || ''
      checkedLogin.value = true // 自动勾选记住密码选项
      // console.log('已自动填充账号和密码')
    } catch (e) {
      // console.error('解析记住的账号和密码时出错:', e)
    }
  } else {
    // console.log('localStorage中没有找到记住的凭据')
  }
})

// 监听记住账号和密码选项的变化
watch(checkedLogin, (newVal) => {
  // console.log('记住密码选项变化:', newVal)
  if (!newVal) {
    // 如果取消勾选，清除保存的账号和密码
    localStorage.removeItem(REMEMBER_CREDENTIALS_KEY) // console.log('用户取消勾选，已清除保存的账号和密码')
  }
})

async function loginHandle(values) {
  if (verifyInputLogin1() || verifyInputLogin2()) {
    verifyInputLogin1()
    verifyInputLogin2()
    return
  }
  // 登录 设备参数
  try {
    loading.value = true
    const deviceData = await getDeviceInfo()
    const urlParams = new URLSearchParams(window.location.search)
    let inviteCode = urlParams.get('id') || ''
    let channelId = urlParams.get('channel_id') || ''
    let businessId = urlParams.get('business_id') || ''
    if (inviteCode || channelId || businessId) {
      localStorage.setItem('id', inviteCode || '')
      localStorage.setItem('channel_id', channelId || '')
      localStorage.setItem('business_id', businessId || '')
    } else {
      inviteCode = localStorage.getItem('id') || ''
      channelId = localStorage.getItem('channel_id') || ''
      businessId = localStorage.getItem('business_id') || ''
    }
    // console.log('urlParams:', urlParams)

    await userStore
      .handleLogin({
        ...postData,
        ...values,
        password: postData.password.trim(),
        ...deviceData,
        url: window.location.href,
        id: inviteCode, // 邀请码
        channel_id: channelId, // 渠道id
        business_id: businessId, // 商家id
      })
      .then((res) => {
        // 如果用户选择了记住账号和密码，则保存账号和密码
        if (checkedLogin.value) {
          const credentials = {
            username: postData.username,
            password: postData.password,
          }
          localStorage.setItem(REMEMBER_CREDENTIALS_KEY, JSON.stringify(credentials))
        } else {
          // 如果没有选择记住账号和密码，确保清除已保存的账号和密码
          localStorage.removeItem(REMEMBER_CREDENTIALS_KEY)
        }
        // try {
        //   localStorage.removeItem('id')
        // } catch (error) {
        //   //
        // }
        // initPath()
        handleCloseLoginRegisterPopup()
        if (
          router.currentRoute.value &&
          router.currentRoute.value.redirectedFrom &&
          router.currentRoute.value.redirectedFrom.fullPath
        ) {
          router.push({ path: router.currentRoute.value.redirectedFrom.fullPath })
        } else {
          router.push({ name: 'Home', query: { refresh: Date.now().toString() } })
        }
      })
      .catch((err) => {
        console.log('登录报错~~~', err)
        // handleOpenErrorPopup()
      })
  } finally {
    loading.value = false
  }
}

// 推荐用户名
const similarUsernames = ref([])
const registerHandle = async () => {
  if (isPasswordVisible.value) {
    if (verifyRegistro1() || verifyInputRegistro2() || verifyInputRegistro4()) {
      verifyRegistro1()
      verifyInputRegistro2()
      verifyInputRegistro4()
      return
    }
  } else {
    if (
      verifyRegistro1() ||
      verifyInputRegistro2() ||
      verifyInputRegistro3() ||
      verifyInputRegistro4()
    ) {
      verifyRegistro1()
      verifyInputRegistro2()
      verifyInputRegistro3()
      verifyInputRegistro4()
      return
    }
  }

  // 协议勾选
  if (!checkedReg.value) {
    errorToast(t('login-register-popup-index.checkAgreement'))
    return
  }

  if (accountSwitchType.value === PHONE) {
    postDataReg.phone = postDataReg.username
  }

  try {
    loading.value = true
    const deviceData = await getDeviceInfo()
    const urlParams = new URLSearchParams(window.location.search)
    let inviteCode = urlParams.get('id') || ''
    let channelId = urlParams.get('channel_id') || ''
    let businessId = urlParams.get('business_id') || ''
    if (inviteCode || channelId || businessId) {
      localStorage.setItem('id', inviteCode || '')
      localStorage.setItem('channel_id', channelId || '')
      localStorage.setItem('business_id', businessId || '')
    } else {
      inviteCode = localStorage.getItem('id') || ''
      channelId = localStorage.getItem('channel_id') || ''
      businessId = localStorage.getItem('business_id') || ''
    }
    // console.log('urlParams2:', urlParams)
    // 注册 设备参数
    const reModal = {
      username: postDataReg.username,
      password: postDataReg.password.trim(),
      password_confirm: postDataReg.password.trim(), // password_confirm
      phone: postDataReg.phone,
      id: inviteCode, // 邀请码
      channel_id: channelId, // 渠道id
      business_id: businessId, // 商家id
      url: window.location.href,
      ...deviceData,
    }
    const res = await userStore.register(reModal)
    if (res.code == 1039) {
      similarUsernames.value = res.data.similar_usernames
      return
    }
    if (res.code == 1) {
      // initPath()

      localStorage.setItem('is_register_success_greetings_show', 'show')
      handleCloseSuccessRegisterPopup()
      // 页面跳到首页 并通知刷新数据
      // eventBus.emit('refreshHomeInfo')
      // router.push({ name: 'Home' })
      if (
        router.currentRoute.value &&
        router.currentRoute.value.redirectedFrom &&
        router.currentRoute.value.redirectedFrom.fullPath
      ) {
        router.push({ path: router.currentRoute.value.redirectedFrom.fullPath })
      } else {
        router.push({ name: 'Home', query: { refresh: Date.now().toString() } })
      }
      // 清空表单数据
      postDataReg.password = ''
      postDataReg.username = ''
      postDataReg.phone = ''
      postDataReg.password_confirm = ''
    } else {
      // showNotify({ type: 'error', message: res.message || '注册失败' })
    }
  } finally {
    loading.value = false
  }
}

const isComposing = ref(false)

const handleUsernameKeydown = (event) => {
  // 允许的按键：字母、数字、退格、删除、Tab、Escape、Home、End、方向键
  const allowedKeys = [
    'Backspace',
    'Delete',
    'Tab',
    'Escape',
    'Enter',
    'ArrowLeft',
    'ArrowRight',
    'ArrowUp',
    'ArrowDown',
    'Home',
    'End',
  ]

  // 允许的字符正则表达式（字母和数字）
  const allowedCharPattern = /[a-zA-Z0-9]/

  // 如果正在使用输入法，不阻止输入
  if (isComposing.value) {
    return
  }

  // 如果是允许的特殊按键，直接允许
  if (allowedKeys.includes(event.key)) {
    return
  }

  // 如果是Ctrl、Alt、Meta组合键，允许（以便用户可以复制粘贴等操作）
  if (event.ctrlKey || event.altKey || event.metaKey) {
    return
  }

  // 如果字符不符合要求，阻止输入
  if (!allowedCharPattern.test(event.key)) {
    event.preventDefault()
  }
}

const handleCompositionStart = () => {
  isComposing.value = true
}

const handleCompositionEnd = (event) => {
  isComposing.value = false
  // 在输入法结束时，过滤掉非法字符
  const value = event.target.value
  const filteredValue = value.replace(/[^a-zA-Z0-9]/g, '')
  postDataReg.username = filteredValue
}

const handleUsernameInput = (event) => {
  // 如果正在使用输入法，不处理input事件
  if (isComposing.value) {
    return
  }

  // 作为后备保护，再次过滤输入内容
  const value = event.target.value
  const filteredValue = value.replace(/[^a-zA-Z0-9]/g, '')
  postDataReg.username = filteredValue
}

const handleLoginUsernameKeydown = (event) => {
  // 允许的按键：字母、数字、退格、删除、Tab、Escape、Home、End、方向键
  const allowedKeys = [
    'Backspace',
    'Delete',
    'Tab',
    'Escape',
    'Enter',
    'ArrowLeft',
    'ArrowRight',
    'ArrowUp',
    'ArrowDown',
    'Home',
    'End',
  ]

  // 允许的字符正则表达式（字母和数字）
  const allowedCharPattern = /[a-zA-Z0-9]/

  // 如果正在使用输入法，不阻止输入
  if (isComposing.value) {
    return
  }

  // 如果是允许的特殊按键，直接允许
  if (allowedKeys.includes(event.key)) {
    return
  }

  // 如果是Ctrl、Alt、Meta组合键，允许（以便用户可以复制粘贴等操作）
  if (event.ctrlKey || event.altKey || event.metaKey) {
    return
  }

  // 如果字符不符合要求，阻止输入
  if (!allowedCharPattern.test(event.key)) {
    event.preventDefault()
  }
}

const handleLoginUsernameInput = (event) => {
  // 如果正在使用输入法，不处理input事件
  if (isComposing.value) {
    return
  }

  // 作为后备保护，再次过滤输入内容
  const value = event.target.value
  const filteredValue = value.replace(/[^a-zA-Z0-9]/g, '')
  postData.username = filteredValue
}

const handleLoginCompositionStart = () => {
  isComposing.value = true
}

const handleLoginCompositionEnd = (event) => {
  isComposing.value = false
  // 在输入法结束时，过滤掉非法字符
  const value = event.target.value
  const filteredValue = value.replace(/[^a-zA-Z0-9]/g, '')
  postData.username = filteredValue
}

/**
 * 忘记密码
 */
const forgetPasswordVisible = ref(false)
const handleForgetPwd = () => {
  handleCloseLoginRegisterPopup()
  forgetPasswordVisible.value = true
}

const closeForgetPwd = () => {
  forgetPasswordVisible.value = false
  handleOpenLoginRegisterPopup()
}

// 跳转到客户端
const toCliente = () => {
  const list = pathsStore.getPaths() || []
  const targetItem = list.find((item) => item.type == 2)
  if (targetItem && targetItem.url) {
    window.open(targetItem.url)
  } else {
    console.warn('未找到ID对应的链接:', id)
  }
}

const handleOpenLoginRegisterPopup = () => {
  // 首先清空响应式数据
  postDataReg.username = ''
  postDataReg.password = ''
  postDataReg.password_confirm = ''
  postDataReg.phone = ''

  nextTick(() => {
    // 延迟打开弹窗
    LoginRegisterPopupRef.value.open()
  })
}

const openPopupRegLogin = (type) => {
  activeName.value = type || 'register'
  handleOpenLoginRegisterPopup()
}

defineExpose({ openPopupRegLogin })
</script>

<style scoped lang="scss">
.popup-view {
  width: calc(100vw - 30px);
  padding: 0 5px;
  .account-switch-type {
    margin: 10px 0;
    .radio-item {
      --van-radio-border-color: var(--color-61);
      :deep(.van-radio__icon) {
        .van-icon {
          color: var(--color-49);
          border-radius: 3px;
        }
      }
      :deep(.van-radio__label) {
        font-size: 11px;
        color: #ffffff;
      }
    }
  }
  .suporte-content-text {
    margin-top: 6px;
    font-size: 11px;
    line-height: 2;
    color: var(--login-popup-tips-content);
  }

  :deep(.van-tabs__wrap) {
    height: 35px;
    .van-tabs__nav {
      background-color: var(--login-popup-van-tabs-bg);
    }
  }

  .tabs-bot-line {
    width: 100%;
    height: 1px;
    background-color: var(--login-popup-tab-border-bottom);
  }

  .tab-header-container {
    position: relative;
    gap: 3px;

    .icon {
      &.register {
        height: 14px;
      }
      &.login {
        width: 13px;
      }
    }
    .title {
      font-size: 13px;
    }
  }
}
.error-header {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 14px;

  .title {
    margin-left: 4px;
    font-size: 16px;
    color: var(--login-popup-error-text);
  }
}
.error-content {
  .prompt {
    font-size: 12px;
    text-align: center;
  }
  .button {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    padding: 8px 0;
    background-color: #222222;
    border-radius: 8px;
    font-size: 14px;
    color: #ffffff;
  }
}
.custom-label + .custom-label {
  margin-top: 10px;
}
.custom-label {
  width: 315px;
  --van-field-label-width: 0;
  padding: 4px 10px;
  background-color: var(--login-popup-input-bg);
  border: 1px solid var(--login-popup-input-border);
  border-radius: 10px;
  --van-field-icon-size: 14px;
  --van-field-input-text-color: var(--login-popup-input-text);
  --van-field-label-color: var(--login-popup-error-text);
  --van-field-clear-icon-color: var(--login-popup-clear-icon);

  &.label-line {
    :deep(.van-field__label) {
      position: relative;
      padding-left: 20px;
      margin-right: 7px;

      label {
        top: 3px;
      }

      &::after {
        position: absolute;
        top: 50%;
        right: 10px;
        transform: translateY(-50%);
        content: '';
        height: 80%;
        border-right: 1px solid var(--login-popup-input-label-line);
      }
    }
  }

  &.user-name,
  &.confirm-again {
    :deep(.van-field__label) {
      label {
        top: 6px;
      }
    }
  }

  :deep(.van-field__label) {
    margin-right: 7px;

    label {
      position: absolute;
      top: 5px;
      height: 20px;
    }
  }

  :deep(.van-field__body) {
    height: 100%;

    .van-field__control {
      font-size: 12px;
      font-weight: 700;

      &::placeholder {
        font-size: 12px;
        font-weight: 400;
      }
    }
  }

  .field-right-container {
    font-size: 10px;
    color: var(--login-popup-input-placeholder);
  }
}

.register-row {
  color: var(--login-popup-acordo-value);
  font-size: 11px;
}
.register-btn {
  width: 70vw;
  margin-top: 20px;
}

.user-icon {
  width: 15px;
  height: 15px;
}

.lock-icon {
  width: 12px;
}

.eye-icon {
  width: 17px;
}

.eye-close-icon {
  width: 17px;
}

.login-tip {
  font-family: Roboto, Roboto;
  font-weight: 400;
  font-size: 11px;
  text-align: center;
  font-style: normal;
  text-transform: none;
  margin: 14px 20px 0 20px;

  .left-text {
    color: var(--login-popup-acordo-value);
  }
  .right-text {
    color: var(--login-popup-acordo-value);
  }
}

.forca-container {
  margin: 5px 0;

  .forca {
    color: var(--login-popup-forca-label);
    margin-right: 10px;
    font-size: 11px;
  }

  .forca-level-other {
    width: 40px;
    height: 6px;
    border-radius: 6px;
    background-color: var(--login-popup-forca-bg);
    margin-right: 10px;
  }

  .forca-level {
    width: 40px;
    height: 6px;
    border-radius: 6px;
    background-color: var(--login-popup-forca-value);
    margin-right: 10px;
  }
}

.van-icon {
  cursor: pointer; /* 鼠标悬停时显示为手型 */
}

// .van-icon:hover {
//   color: var(--primary-color); /* 高亮颜色 */
// }

.custom-icon {
  font-size: 22px;
}

.icon-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 24px;
}

.login-pt-icon {
  margin: 0 5px 0 2px;
  width: 18px;
}

.login-pt-55 {
  // line-height: 27px;
  font-size: 12px;
  color: var(--van-field-placeholder-text-color);
}

.determina {
  margin-top: 20px;
  font-family: Roboto, Roboto;
  font-size: 10px;
  color: var(--login-tenho-color);
  text-align: left;
  font-style: normal;
  text-transform: none;

  .determina-text {
    width: 292px;
    flex: none;
  }

  .label {
    font-size: 11px;
    color: var(--login-popup-acordo-label);
  }

  .acordo {
    color: var(--login-popup-acordo-value);
  }
}
.lembrar {
  margin-top: 15px;
  font-size: 11px;
  color: var(--login-popup-acordo-value);
}
.checkbox-item {
  margin-right: 6px;
  height: 17px;
  --van-checkbox-size: 16px;
  --van-checkbox-border-color: var(--login-popup-checkbox-border);
  --van-checkbox-checked-icon-color: var(--login-popup-checkbox-icon-color);

  :deep(.van-checkbox__icon) {
    .van-icon {
      width: 17px;
      border-radius: 4px;
    }
  }
}

.submit-button-box {
  position: relative;
  width: 313px;
  height: 33px;

  .position-center {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    background-color: var(--login-popup-confirm-bg);
    border: none;
  }

  .submit-button-border-ani {
    @extend .position-center;
    z-index: 1;
    border-radius: 12px;
    animation: __ScaleBorderAni 1.5s cubic-bezier(0.41, -0.01, 0, 0.54) infinite;

    @keyframes __ScaleBorderAni {
      0% {
        opacity: 0;
        width: 100%;
        height: 100%;
        transform: translate(-50%, -50%) scale(1);
      }

      20% {
        opacity: 0.88;
      }

      60% {
        opacity: 0;
      }

      100% {
        opacity: 0;
        width: calc(100% + 18px);
        height: calc(100% + 16px);
        transform: translate(-50%, -50%) scale(1.06);
      }
    }
  }

  .submit-button {
    @extend .position-center;
    z-index: 2;
    border-radius: 8px;
    color: var(--login-popup-confirm-text);
    animation: __ScaleAni 750ms cubic-bezier(0.41, -0.01, 0, 0.54) infinite alternate;

    &.register-button,
    &.login-button {
      font-size: 12px;
    }

    @keyframes __ScaleAni {
      0% {
        transform: translate(-50%, -50%) scale(1.02);
      }

      100% {
        transform: translate(-50%, -50%) scale(1.03);
      }
    }
  }
}

.registroerror {
  display: flex;
  align-items: flex-start;
  min-height: 14px;
  font-size: 12px;
  margin-top: 5px;
  margin-bottom: 8px;

  .registroerror-icon {
    width: 13px;
    height: 13px;
    margin-right: 2px;
  }
  .registroerror-text {
    flex: 1;
    font-size: 12px;
    color: var(--special-red-10);
    white-space: pre-line;
    line-height: 1.3;
  }
  .username-text {
    margin-right: 10px;
    color: var(--login-popup-tips-content__special);
  }
}

.loading-dots {
  display: inline-flex;
  align-items: center;
  gap: 4px;

  &::after {
    content: '•••';
    letter-spacing: 2px;
    color: var(--login-popup-confirm-text);
    animation: dot-blink 1.2s ease-in-out infinite;
  }
}

@keyframes dot-blink {
  0%,
  100% {
    opacity: 0.3;
  }
  50% {
    opacity: 1;
  }
}

// 这个模板都是345px弹窗宽度
.van-popup--center {
  width: 345px;
  margin: auto 15px;
}
</style>
